/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
export const SET_APP_STATE = 'SET_APP_STATE';

export const CONNECTION_SHEET_EVENT_ERROR = 'CONNECTION_SHEET_EVENT_ERROR';


// Admin constants
export const ERROR = 'ERROR';

export const NOTIFICATIONS_CLEAR = 'notifications_clear';

// Backup & Restore

export const SEND_RESTORE_SUCCESS = 'SEND_RESTORE_SUCCESS';
export const SEND_RESTORE_ERROR = 'SEND_RESTORE_ERROR';
